import React from 'react';
import { ArrowLeft, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useCredits } from '../../contexts/CreditsContext';

interface CatalogueMainHeaderProps {
    username: string;
    credits: number;
    backButton?: boolean;
}

export const CatalogueMainHeader: React.FC<CatalogueMainHeaderProps> = ({
    username,
    backButton = false
}) => {
    const navigate = useNavigate();
    const { credits } = useCredits();

    return (
        <div className="w-full border-b border-border mt-[60px] md:mt-0">
            <div className="flex items-center justify-between px-4 py-3">
                <div>
                    { backButton ? (
                        <button
                            onClick={ () => navigate('/catalogue') }
                            className="flex items-center gap-2 text-sm text-muted-foreground hover:text-card-foreground transition-colors cursor-pointer"
                        >
                            <ArrowLeft size={ 16 } />
                            Back to projects
                        </button>
                    ) : (
                        <div className="border flex gap-3 items-center border-border rounded-lg px-4 py-2">
                            <h1 className="text-lg font-semibold text-card-foreground">
                                Fast Track
                            </h1>
                        </div>
                    ) }
                </div>

                <div className="flex items-center gap-2">
                    <User size={ 16 } className="text-muted-foreground" />
                    <span className="text-sm text-muted-foreground">{ username }</span>
                    <div className="ml-2 px-3 py-1 rounded-full bg-muted text-sm font-medium text-muted-foreground">
                        { typeof credits === 'number' ? `${credits} credits` : '...' }
                    </div>
                </div>
            </div>
        </div>
    );
};
